import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noBlankValidator(): ValidatorFn {
  return (control: FormControl): ValidationErrors | null => {
    if (control?.value?.length <= 0) {
      return null;
    }
    const value = control.value;

    return (value instanceof String || typeof value === 'string') &&
      control.value.trim() === ''
      ? { required: true }
      : null;
  };
}
